import { getTestId } from '@airtel/air-design-system';
var accordianListArray = [{
  content: {
    dataArray: [{
      content: [{
        text: 'An eSIM is an online extension of your regular SIM card. This SIM can be downloaded and exists as a digital version. With an eSIM card, you will no longer need to have access to the physical SIM card of your phone.',
        type: 'body-para-sm'
      }]
    }]
  },
  id: 'accordion 1',
  onPress: {
    id: 'accordion 1'
  },
  title: {
    text: 'What is eSIM or eSIM card? '
  }
}, {
  content: {
    dataArray: [{
      content: [{
        text: 'An eSIM is an online extension of your regular SIM card. This SIM can be downloaded and exists as a digital version. With an eSIM card, you will no longer need to have access to the physical SIM card of your phone.',
        type: 'body-para-sm'
      }]
    }]
  },
  id: 'accordion 1',
  onPress: {
    id: 'accordion 1'
  },
  title: {
    text: 'What is eSIM or eSIM card? '
  }
}];
var compareSectionProps = Object.assign({
  id: 'ComparisonViewCardWidgetContainer',
  showDropDown: true,
  dropDownDetails: {
    dropdownList: [{
      subHeading: '₹199 plan',
      value: '199'
    }, {
      subHeading: '₹299 plan',
      value: '299'
    }, {
      subHeading: '₹399 plan',
      value: '399'
    }, {
      subHeading: '₹499 plan',
      value: '499'
    }],
    label: 'select plan',
    filterKey: 'subHeading',
    onDropDownSelectionMetaData: {
      id: 'drop-down-item'
    }
  },
  planDetailsList: [{
    value: '199',
    planCardDetails: {
      title: 'Airtel infinity ₹1,999 plan',
      priceDetails: {
        gstDetails: 'incl. GST',
        offerText: 'save ₹100',
        oldPrice: '₹598.00',
        price: '₹1,234'
      },
      infoTagArray: [{
        subType: 'default',
        text: 'bestseller'
      }],
      buttonWidgetData: {
        direction: 'row',
        leftCta: {
          buttonType: 'secondary',
          title: 'BUY NOW',
          version: 'variable-width'
        },
        onLeftCtaPress: {
          id: 'left-cta'
        }
      }
    },
    benefitsListData: {
      showExpandCta: true,
      expandCTAData: {
        initialItemCount: 25
      },
      benefitsList: [{
        heading: '75 GB',
        subHeading: 'Data'
      }, {
        avatarIcon: 'CancelFilledIcon',
        avatarProps: {
          noBgContainer: true,
          variant: 'icon',
          iconProps: {
            color: '#A0A2A4',
            fill: '#FFF'
          }
        },
        isIconTitle: true,
        heading: 'Buy Now!',
        subHeading: 'Local/STD calls'
      }, {
        isHyperLinkTitle: true,
        heading: '299 days',
        subHeading: 'Validity',
        hyperLinkActionMetaData: {
          id: '199'
        }
      }, {
        heading: '7 OTT',
        subHeading: 'Benefits',
        style: {
          marginBottom: 12
        }
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }]
    },
    accordionList: accordianListArray
  }, {
    value: '299',
    planCardDetails: {
      title: 'Airtel infinity ₹1,999 plan',
      priceDetails: {
        gstDetails: 'incl. GST',
        offerText: 'save ₹100',
        oldPrice: '₹598.00',
        price: '₹1,235'
      },
      infoTagArray: [{
        subType: 'default',
        text: 'bestseller'
      }],
      buttonWidgetData: {
        direction: 'row',
        leftCta: {
          buttonType: 'secondary',
          title: 'BUY NOW',
          version: 'variable-width'
        },
        onLeftCtaPress: {
          id: 'left-cta'
        }
      }
    },
    benefitsListData: {
      showExpandCta: true,
      expandCTAData: {
        initialItemCount: 13
      },
      benefitsList: [{
        heading: '75 GB',
        subHeading: 'Data'
      }, {
        avatarIcon: 'CancelEnclosedIcon',
        avatarProps: {
          noBgContainer: true,
          variant: 'icon'
        },
        isIconTitle: true,
        heading: 'Buy Now!',
        subHeading: 'Local/STD calls'
      }, {
        isHyperLinkTitle: true,
        heading: '299 days',
        subHeading: 'Validity',
        hyperLinkActionMetaData: {
          id: '299'
        }
      }, {
        heading: '1 sim | 20 GB data | 20 sms',
        subHeading: 'Free add-ons'
      }, {
        heading: '7 OTT',
        subHeading: 'Benefits',
        style: {
          marginBottom: 12
        }
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }]
    },
    accordionList: accordianListArray
  }, {
    value: '399',
    planCardDetails: {
      title: 'Airtel infinity ₹1,999 plan',
      priceDetails: {
        gstDetails: 'incl. GST',
        offerText: 'save ₹100',
        oldPrice: '₹598.00',
        price: '₹1,236'
      },
      infoTagArray: [{
        subType: 'default',
        text: 'bestseller'
      }],
      buttonWidgetData: {
        direction: 'row',
        leftCta: {
          buttonType: 'secondary',
          title: 'BUY NOW',
          version: 'variable-width'
        },
        onLeftCtaPress: {
          id: 'left-cta'
        }
      }
    },
    benefitsListData: {
      showExpandCta: true,
      expandCTAData: {
        initialItemCount: 13
      },
      benefitsList: [{
        heading: '75 GB',
        subHeading: 'Data'
      }, {
        avatarIcon: 'CancelEnclosedIcon',
        avatarProps: {
          noBgContainer: true,
          variant: 'icon'
        },
        isIconTitle: true,
        heading: 'Buy Now!',
        subHeading: 'Local/STD calls'
      }, {
        isHyperLinkTitle: true,
        heading: '299 days',
        subHeading: 'Validity',
        hyperLinkActionMetaData: {
          id: '399'
        }
      }, {
        heading: '1 sim | 20 GB data | 20 sms',
        subHeading: 'Free add-ons'
      }, {
        heading: '7 OTT',
        subHeading: 'Benefits',
        style: {
          marginBottom: 12
        }
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }]
    },
    accordionList: accordianListArray
  }, {
    value: '499',
    planCardDetails: {
      title: 'Airtel infinity ₹1,999 plan',
      priceDetails: {
        gstDetails: 'incl. GST',
        offerText: 'save ₹100',
        oldPrice: '₹598.00',
        price: '₹1,237'
      },
      infoTagArray: [{
        subType: 'default',
        text: 'bestseller'
      }],
      buttonWidgetData: {
        direction: 'row',
        leftCta: {
          buttonType: 'secondary',
          title: 'BUY NOW',
          version: 'variable-width'
        },
        onLeftCtaPress: {
          id: 'left-cta'
        }
      }
    },
    benefitsListData: {
      showExpandCta: true,
      expandCTAData: {
        initialItemCount: 13
      },
      benefitsList: [{
        heading: '75 GB',
        subHeading: 'Data'
      }, {
        avatarIcon: 'CancelEnclosedIcon',
        avatarProps: {
          noBgContainer: true,
          variant: 'icon'
        },
        isIconTitle: true,
        heading: 'Buy Now!',
        subHeading: 'Local/STD calls'
      }, {
        isHyperLinkTitle: true,
        heading: '299 days',
        subHeading: 'Validity',
        hyperLinkActionMetaData: {
          id: '499'
        }
      }, {
        heading: '1 sim | 20 GB data | 20 sms',
        subHeading: 'Free add-ons'
      }, {
        heading: '7 OTT',
        subHeading: 'Benefits',
        style: {
          marginBottom: 12
        }
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }, {
        benefitImageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
        heading: 'OTT / Benefit 1'
      }]
    },
    accordionList: accordianListArray
  }],
  showListSubtitleSection: true,
  listTitleSectionProps: {
    subTitle: 'sub title',
    hideBottomPadding: true,
    hideTopPadding: true
  }
}, getTestId('ComparisonViewCardWidgetContainer'));
export var defaultProps = Object.assign({
  id: 'ComparisonViewCardWidgetContainer',
  comparisonViewCardList: [compareSectionProps]
}, getTestId('ComparisonViewCardWidgetContainer'));